@if (showButton()) {
    <ion-button color="gray" (click)="invite()" fill="outline">
        <span [hidden]="isLoading" style="padding: 5px;">{{'Invite' | translate}}</span>
        <ion-spinner [hidden]="!isLoading" name="crescent"></ion-spinner>
    </ion-button>
}
